import React from 'react';
import SelectField from '../../../forms/_fields_v2/SelectField';
import useRouter from '../../../hooks/useRouter';
import useNavigationLinks from '../Sidebar/useNavigationLinks';

export default function SchoolYearSelectField(props) {
  const { location, history } = useRouter();

  const { schoolYearLinks, currentSchoolYearLink } = useNavigationLinks();

  return (
    <SelectField
      label="School year"
      value={currentSchoolYearLink.href}
      // placeholder="Select page..."
      options={{
        data: schoolYearLinks.map(function(link, index) {
          return {
            id: link.href,
            data: {
              name: link.name
            }
          };
        })
      }}
      optionLabel="name"
      onChange={function(id) {
        const tokens = location.pathname.split(currentSchoolYearLink.href);
        history.push(`${id}${tokens[1]}`);
      }}
    />
  );
}
